module.exports = __webpack_public_path__ + "img/logo-white.b2647d81.png";